import { Component, input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { FontIconComponent } from '@camelot/icons';
import { LinkComponent, TextComponent } from '@camelot/ui';
import { SafePipe } from '@camelot/utils';

import { Communication, CommunicationParticipantExtended } from '../../../services/dto/communication';
import { CamTranslationCommunication } from '../../../translation.service';
import { LightComponent } from '../../participant/light/light.component';
import { ResponseToCommunicationComponent } from './response-to-communication/response-to-communication.component';

@Component({
  selector: 'cam-communication-message-mail',
  templateUrl: './message-mail.component.html',
  styleUrls: ['./message-mail.component.scss'],
  imports: [
    TranslateModule,
    TextComponent,
    LinkComponent,
    SafePipe,
    ResponseToCommunicationComponent,
    FontIconComponent,
    LightComponent,
  ],
})
export class MessageMailComponent {
  conversationParticipants = input.required<CommunicationParticipantExtended[]>();

  communication = input.required<Communication>();

  taskId = input.required<string>();

  public expand = false;
  public showFullText: boolean = false;
  public showResponsteToCommunication: boolean = false;

  constructor() {
    CamTranslationCommunication.getInstance();
  }
}
